import { useDispatch, useSelector } from 'react-redux';

import {
  AccountBalance,
  AccountBox,
  ArtTrack,
  Assignment,
  AssignmentInd,
  AttachMoney,
  BorderColor,
  Category,
  Equalizer,
  Description,
  Domain,
  EnhancedEncryption,
  FileCopyOutlined,
  Group,
  ImportContacts,
  Home,
  HowToReg,
  Iso,
  ListAlt,
  LocalAtm,
  LocalHospitalSharp,
  People,
  PermIdentity,
  PersonOutline,
  SupervisedUserCircle,
  Settings,
  Stars,
  Today,
  PostAdd,
  MonetizationOn,
  Shop,
  LocalPharmacy,
  Accessible,
  FolderShared,
  LocalHospital,
  PersonAdd,
  MenuBookSharp,
  AspectRatio,
  GroupAdd,
  AllInclusive,
  Phone,
  DeviceHub,
  FeaturedPlayList,
  AttachFile,
  AirportShuttle,
  FormatListNumberedRtl,
  EventNoteSharp,
  Cached,
  PostAddOutlined,
  Person,
  QueryBuilder,
  Add,
  ArrowForward,
  MonetizationOnSharp,
  Airplay,
  Inbox,
  List,
  LowPriority,
  Shuffle,
  MoneyOffSharp
} from '@material-ui/icons';
import {
  ADMINISTRAR_PREAFILIACIONES_PERMISOS,
  AFILIACIONES_PERMISOS,
  ARCHIVOS_PERMISOS,
  BANDEJA_PERMISOS,
  CATEGORIA_PERMISOS,
  CATEGORIA_TIPO_AFILIADO_PERMISOS,
  CONFIGURACIONTURNOS_PERMISOS,
  CONTRATACIONES_PERMISOS,
  CUOTASFACTURACION_PERMISOS,
  DOCUMENTOS_PARENTESCO_PERMISOS,
  DOCUMENTOS_TIPO_PERMISOS,
  EMPRESAS_PERMISOS,
  ESPECIALIDADES_PERMISOS,
  ESTADISTICAS_MI_OSPEDYC,
  ESTADO_CIVIL_PERMISOS,
  FACTURACION_PERMISOS,
  FERIADOS_PERMISOS,
  LICENCIASPROFESIONALES_PERMISOS,
  MEDICOS_PERMISOS,
  MOTIVOSBAJATURNOS_PERMISOS,
  PERMISOS_PERMISOS,
  ROLES_PERMISOS,
  REPORTES_PERMISOS,
  RESOLUCIONESFACTURACION_PERMISOS,
  SOPORTEAFILIADOS_PERMISOS,
  TIPO_AFILIACION_PERMISOS,
  TIPO_DOCUMENTACION_PERMISOS,
  TIPO_PARENTESCO_PERMISOS,
  TOPES_MINIMOS_PERMISOS,
  TURNOS_PERMISOS,
  USUARIOS_PERMISOS,
  AUTORIZACIONES_MENU_PERMISOS,
  ADMINISTRAR_AUTORIZACIONES_PERMISOS,
  MATERIALES,
  TIPOS_DOCUMENTACION_SOLICITUD,
  TIPOS_DOCUMENTACION_PRACTICA_SOLICITUD,
  TIPOS_DOCUMENTACION,
  ADMINISTRAR_PRESUPUESTOS_PERMISOS,
  REPORTE_DINAMICO_PERMISOS,
  MESA_ENTRADA_PERMISOS,
  CONFIGURACION_CONTRATOS,
  ARCHIVOS_CONTRATACIONES,
  EFECTORES_LIQUIDADOR_PERMISOS,
  LIQUIDACIONES_MENU_PERMISOS,
  ADMINISTRAR_LIQUIDACIONES_PERMISOS,
  RECETAS_MENU_PERMISOS,
  COMPRAS_MENU_PERMISOS,
  REPORTES_CONTRATACIONES,
  DISCAPACIDAD_PERMISOS,
  EMPADRONAMIENTO_MENU_PERMISOS,
  MEDICACION_MENU_PERMISOS,
  ADMINISTRAR_DISCAPACIDAD_PERMISOS,
  MENU_RECUPEROS,
  RECLAMOS_PERMISOS,
  TOTEM_PERMISOS,
  //EFECTORES_AUDITORIA_TERRENO_PERMISOS,
  RELACION_PRACTICA_BANDEJA,
  COMUNICACION_CON_EMPRESAS_PERMISOS,
  DISCAPACIDAD_NOMENCLADOR_PERMISOS,
  RECUPERO,
  HCE_PERMISOS,
  ADMINISTRAR_ADICCIONES_PERMISOS,
  ADICCIONES_PERMISOS,
  AUTORIZACIONES_PRACTICAS_AGRUPADAS,
  TESORERIA_PERMISOS,
  TOTEM_BASIC_PERMISOS,
} from "../../utils/permisos";
import { MenuGeneric } from "../compartidos/MenuGeneric";
import { validarQueTengaAunqueSeaUnSoloPermiso, validarSoloUnPermiso } from "../../helpers/permisos";
import { desSeleccionarContrato } from "../../actions/contrataciones/contrataciones";
import { useTotem } from "../../hooks/useCases/useTotem";
import { cleanTipoDocumentacionAbm } from '../../actions/discapacidad/discapacidadActions';
import { cleanTipoDocumentacionAbmAdicciones } from '../../actions/adicciones/adiccionesActions';
import { useSurge } from '../../hooks/useCases/useSurge';
import { useTraslados } from '../../hooks/useCases/useTraslados';
import { clearReducer } from '../../actions/recetasDigitales/RecetasDigitales';
import { clearReducerHce } from '../../actions/hce/hceActions';
import { clearReducer as clearReducerEmp, getTiposEmpadronamiento, setIdTipoEmpadronamiento } from '../../actions/empadronamiento/Empadronamiento';
import { IconoCios } from '../cios/IconoCios';
import { AUTORIZACIONES_BANDEJAS, TIPO_EMPADRONAMIENTO } from '../../utils/constants';
import { useEffect } from 'react';

export const MenuIzquierda = ({ handleclose }) => {
  const dispatch = useDispatch();
  const totem = useTotem();
  const surge = useSurge();
  const { permisos: permisosTraslados } = useTraslados();
  const { permisos: permisosUser, bandejasAutorizacion = [] } = useSelector((state) => state.auth);
  const { tiposEmpadronamiento} = useSelector((state) => state.empadronamiento);

  const esSoloAfiliaciones = bandejasAutorizacion.length === 1
    && bandejasAutorizacion.filter(s => s.idBandeja === AUTORIZACIONES_BANDEJAS.AFILIACIONES).length === 1;

  const resetState = () => {
    dispatch(clearReducer());
    dispatch(clearReducerHce());
    dispatch(clearReducerEmp());
  };

  useEffect(()=>{
    dispatch(getTiposEmpadronamiento());
  },[dispatch])

  return (
    <MenuGeneric
      title="Beneficiarios"
      cerrarMenu={handleclose}
      baseList={[
        /*A*/
        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            AFILIACIONES_PERMISOS,
            ADMINISTRAR_PREAFILIACIONES_PERMISOS,
            BANDEJA_PERMISOS,
            CATEGORIA_PERMISOS,
            CATEGORIA_TIPO_AFILIADO_PERMISOS,
            CUOTASFACTURACION_PERMISOS,
            DOCUMENTOS_PARENTESCO_PERMISOS,
            DOCUMENTOS_TIPO_PERMISOS,
            EMPRESAS_PERMISOS,
            ESTADO_CIVIL_PERMISOS,
            FACTURACION_PERMISOS,
            REPORTES_PERMISOS,
            RESOLUCIONESFACTURACION_PERMISOS,
            SOPORTEAFILIADOS_PERMISOS,
            TIPO_DOCUMENTACION_PERMISOS,
            TIPO_AFILIACION_PERMISOS,
            TIPO_PARENTESCO_PERMISOS,
          ]),
          icon: People,
          nombre: 'Afiliaciones',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/afiliaciones',
              permisos: AFILIACIONES_PERMISOS,
            },
            {
              icon: ArtTrack,
              nombre: 'Administrar PreAfiliaciones',
              ruta: '/usuarios/administrarPreafiliaciones',
              permisos: ADMINISTRAR_PREAFILIACIONES_PERMISOS,
            },
            {
              icon: Domain,
              nombre: 'Empresas',
              ruta: '/empresas',
              permisos: EMPRESAS_PERMISOS,
            },
            {
              icon: Cached,
              nombre: 'Modificación Familiares',
              ruta: '/afiliaciones/modificaciones',
              permisos: EMPRESAS_PERMISOS,
            },
            {
              icon: People,
              nombre: 'Bandeja',
              ruta: '/afiliaciones/bandeja',
              permisos: BANDEJA_PERMISOS,
            },
            {
              icon: ListAlt,
              nombre: 'Reportes dinamicos Afiliaciones',
              ruta: '/Consultas',
              permisos: REPORTE_DINAMICO_PERMISOS,
            },
            {
              tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(
                permisosUser,
                [
                  CUOTASFACTURACION_PERMISOS,
                  FACTURACION_PERMISOS,
                  RESOLUCIONESFACTURACION_PERMISOS,
                ],
              ),
              icon: LocalAtm,
              nombre: 'Facturación',
              children: [
                {
                  icon: LocalAtm,
                  nombre: 'General',
                  ruta: '/facturacion',
                  permisos: FACTURACION_PERMISOS,
                },
                {
                  icon: AttachMoney,
                  nombre: 'Cuotas',
                  ruta: '/configuracion/facturacion/cuotas',
                  permisos: CUOTASFACTURACION_PERMISOS,
                },
                {
                  icon: AccountBalance,
                  nombre: 'Resoluciones',
                  ruta: '/configuracion/facturacion/resoluciones',
                  permisos: RESOLUCIONESFACTURACION_PERMISOS,
                },
              ],
            },
            {
              icon: PersonOutline,
              nombre: 'Soporte Afiliados',
              ruta: '/soporte-afiliados/contacto',
              permisos: SOPORTEAFILIADOS_PERMISOS,
            },
            {
              tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(
                permisosUser,
                [
                  CATEGORIA_PERMISOS,
                  CATEGORIA_TIPO_AFILIADO_PERMISOS,
                  DOCUMENTOS_PARENTESCO_PERMISOS,
                  DOCUMENTOS_TIPO_PERMISOS,
                  EMPRESAS_PERMISOS,
                  ESTADO_CIVIL_PERMISOS,
                  TIPO_DOCUMENTACION_PERMISOS,
                  TIPO_AFILIACION_PERMISOS,
                  TIPO_PARENTESCO_PERMISOS,
                ],
              ),
              nombre: 'Configuración',
              icon: Settings,
              children: [
                {
                  icon: Category,
                  nombre: 'Categoria',
                  ruta: '/afiliaciones/tiposCategoria',
                  permisos: CATEGORIA_PERMISOS,
                },
                {
                  icon: AssignmentInd,
                  nombre: 'Categoria por tipo Afiliado',
                  ruta: '/afiliaciones/configuracionCategoriaXAfiliado',
                  permisos: CATEGORIA_TIPO_AFILIADO_PERMISOS,
                },
                {
                  icon: AssignmentInd,
                  nombre: 'Documentación por Parentesco',
                  ruta: '/afiliaciones/configuracionParentesco',
                  permisos: DOCUMENTOS_PARENTESCO_PERMISOS,
                },
                {
                  icon: AccountBox,
                  nombre: 'Documentación por Tipo',
                  ruta: '/afiliaciones/configuracionTipo',
                  permisos: DOCUMENTOS_TIPO_PERMISOS,
                },
                {
                  icon: Domain,
                  nombre: 'Empresas',
                  ruta: '/empresas',
                  permisos: EMPRESAS_PERMISOS,
                },
                {
                  icon: Group,
                  nombre: 'Estado Civil',
                  ruta: '/afiliaciones/estadoCivil',
                  permisos: ESTADO_CIVIL_PERMISOS,
                },
                {
                  icon: Assignment,
                  nombre: 'Tipos de Afiliación',
                  ruta: '/afiliaciones/tiposAfiliacion',
                  permisos: TIPO_AFILIACION_PERMISOS,
                },
                {
                  icon: ImportContacts,
                  nombre: 'Tipos de Documentaciones',
                  ruta: '/afiliaciones/tiposDeDocumentaciones',
                  permisos: TIPO_DOCUMENTACION_PERMISOS,
                },
                {
                  icon: Group,
                  nombre: 'Tipos de Parentesco',
                  ruta: '/afiliaciones/tiposParentesco',
                  permisos: TIPO_PARENTESCO_PERMISOS,
                },
                {
                  icon: HowToReg,
                  nombre: 'Topes Minimos',
                  ruta: '/TopesMinimos',
                  permisos: TOPES_MINIMOS_PERMISOS,
                },
              ],
            },
            {
              tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(
                permisosUser,
                [ARCHIVOS_PERMISOS],
              ),
              icon: FileCopyOutlined,
              nombre: 'Archivos Migración',
              ruta: '/afiliaciones/migracion-archivos',
            },
          ],
        },
        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            AUTORIZACIONES_MENU_PERMISOS,
          ]),
          icon: BorderColor,
          nombre: 'Autorizaciones',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/autorizaciones',
              permisos: AUTORIZACIONES_MENU_PERMISOS,
            },
            {
              icon: ArtTrack,
              nombre: 'Administrar Solicitudes',
              ruta: '/autorizaciones/administrarSolicitudes',
              permisos: esSoloAfiliaciones ? [] : ADMINISTRAR_AUTORIZACIONES_PERMISOS,
            },
            {
              icon: ArtTrack,
              nombre: 'Administrar Presupuestos',
              ruta: '/autorizaciones/administrarPresupuestos',
              permisos: esSoloAfiliaciones ? [] : ADMINISTRAR_PRESUPUESTOS_PERMISOS,
            },
            {
              icon: LocalHospital,
              nombre: 'Modificación Internacion',
              ruta: '/autorizaciones/modificacionInternaciones',
              permisos: esSoloAfiliaciones ? [] : TIPOS_DOCUMENTACION,
            },          
            {
              icon: MoneyOffSharp,
              nombre: 'Afiliados Recupero',
              ruta: '/autorizaciones/afiliadosRecupero',
              permisos: esSoloAfiliaciones ? [] : TIPOS_DOCUMENTACION,
            },       
            {
              tienePermiso: esSoloAfiliaciones ? false : validarQueTengaAunqueSeaUnSoloPermiso(
                permisosUser,
                [AUTORIZACIONES_MENU_PERMISOS],
              ),
              icon: Settings,
              nombre: 'Configuración',
              children: [
                {
                  icon: Category,
                  nombre: "Relación Practica Bandeja",
                  ruta: "/autorizaciones/RelacionPracticaBandeja",
                  permisos: RELACION_PRACTICA_BANDEJA
                },
                {
                  icon: EnhancedEncryption,
                  nombre: "Prestadores Restringidos",
                  ruta: "/autorizaciones/prestadoresRestringidos",
                  permisos: TIPOS_DOCUMENTACION
                },
                /*{
                  icon: EnhancedEncryption,
                  nombre: "Efectores Auditoria Terreno",
                  ruta: "/autorizaciones/efectoresAuditoriaTerreno",
                  permisos: EFECTORES_AUDITORIA_TERRENO_PERMISOS
                },*/
                {
                  icon: EnhancedEncryption,
                  nombre: 'Efectores Auditoria Terreno',
                  ruta: '/autorizaciones/efectoresAuditoriaTerreno',
                  permisos: RELACION_PRACTICA_BANDEJA,
                },
                {
                  icon: Description,
                  nombre: 'Tipos De Documentación',
                  ruta: '/autorizaciones/tiposDocumentacion',
                  permisos: TIPOS_DOCUMENTACION,
                },
                {
                  icon: Description,
                  nombre: 'Tipos De Documentación Presupuesto',
                  ruta: '/autorizaciones/tiposDocumentacionPresupuesto',
                  permisos: TIPOS_DOCUMENTACION,
                },
                {
                  icon: Description,
                  nombre: 'Tipos De Documentación Solicitud',
                  ruta: '/autorizaciones/tiposDocumentacionSolicitud',
                  permisos: TIPOS_DOCUMENTACION_SOLICITUD,
                },
                {
                  icon: Description,
                  nombre: 'Tipos De Documentación PracticaSolicitud',
                  ruta: '/autorizaciones/tiposDocumentacionPracticaSolicitud',
                  permisos: TIPOS_DOCUMENTACION_PRACTICA_SOLICITUD,
                },
                {
                  icon: Category,
                  nombre: 'Practicas Agrupadas',
                  ruta: '/autorizaciones/practicasAgrupadas',
                  permisos: AUTORIZACIONES_PRACTICAS_AGRUPADAS,
                },
                {
                  icon: Category,
                  nombre: "Materiales",
                  ruta: "/autorizaciones/materiales",
                  permisos: MATERIALES
                },
                {
                  icon: Category,
                  nombre: "Recupero",
                  ruta: "/autorizaciones/recupero",
                  permisos: RECUPERO
                }
              ]
            }
          ]
        },

        /*C*/

        {
          icon: IconoCios,
          nombre: 'CIOS',
          children: [
            {
              icon: Home,
              ruta: '/',
              nombre: 'Ingresar',
              permisos: null,
              onClick: () => {
                window.open('https://sites.google.com/ospedyc.org.ar/cios/cios', '_blank');
              }
            },
          ],

        },


        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            COMPRAS_MENU_PERMISOS,
          ]),
          icon: Shop,
          nombre: 'Compras',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/compras',
              permisos: null,
            },
            {
              tienePermiso: true,
              nombre: 'Configuración',
              children: [
                {
                  icon: Description,
                  nombre: 'Oferentes',
                  ruta: '/compras/configuracion/oferentes',
                  permisos: null,
                }
              ],
            },
          ],
        },

        {
          icon: Phone,
          nombre: 'Comunicacion con Empresas',
          ruta: '/comunicacion-con-empresas',
          permisos: COMUNICACION_CON_EMPRESAS_PERMISOS,
        },


        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            PERMISOS_PERMISOS,
            ROLES_PERMISOS,
            USUARIOS_PERMISOS,
            EFECTORES_LIQUIDADOR_PERMISOS
          ]),
          icon: SupervisedUserCircle,
          nombre: 'Configuración de Usuarios',
          children: [
            {
              icon: PermIdentity,
              nombre: 'Permisos',
              ruta: '/usuarios/permisos',
              permisos: PERMISOS_PERMISOS,
            },
            {
              icon: Stars,
              nombre: 'Roles',
              ruta: '/usuarios/roles',
              permisos: ROLES_PERMISOS,
            },
            {
              icon: Assignment,
              nombre: 'Reportes por Area',
              ruta: '/ReportesPorArea',
              permisos: null,
            },
            {
              icon: PersonOutline,
              nombre: 'Usuarios',
              ruta: '/usuarios/usuario',
              permisos: USUARIOS_PERMISOS,
            },
            {
              icon: Assignment,
              nombre: 'Efectores por Liquidador',
              ruta: '/efectoresPorLiquidador',
              permisos: EFECTORES_LIQUIDADOR_PERMISOS,
            },
          ],
        },




        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            CONTRATACIONES_PERMISOS,
          ]),
          icon: AssignmentInd,
          nombre: 'Contrataciones',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/contrataciones',
              permisos: CONTRATACIONES_PERMISOS,
              onClick: () => {
                dispatch(desSeleccionarContrato());
              },
            },
            {
              tienePermiso: validarSoloUnPermiso(
                permisosUser,
                CONFIGURACION_CONTRATOS.ADMINISTRAR,
              ),
              icon: Settings,
              nombre: 'Configuración',
              children: [
                {
                  icon: Description,
                  nombre: 'Documentación por Subtipo de Efectores',
                  ruta: '/contrataciones/configuracion/tipo-documentaciones-efector-por-subtipo-efector',
                  permisos: CONFIGURACION_CONTRATOS,
                },
                {
                  icon: HowToReg,
                  nombre: 'Motivos Baja Efectores',
                  ruta: '/contrataciones/configuracion/MotivosBajaEfector',
                  permisos: CONFIGURACION_CONTRATOS,
                },
                {
                  icon: Description,
                  nombre: 'Modulos',
                  ruta: '/contrataciones/configuracion/modulos',
                  permisos: CONFIGURACION_CONTRATOS,
                },
                {
                  icon: Description,
                  nombre: 'Tipos Plazos',
                  ruta: '/contrataciones/configuracion/TiposPlazos',
                  permisos: null,
                },
                {
                  icon: Description,
                  nombre: 'Nomenclador',
                  ruta: '/contrataciones/configuracion/nomenclador',
                  permisos: CONFIGURACION_CONTRATOS,
                },
                {
                  icon: Description,
                  nombre: 'Coseguro',
                  ruta: '/contrataciones/configuracion/coseguros',
                  permisos: CONFIGURACION_CONTRATOS,
                },
                {
                  icon: Description,
                  nombre: 'Coseguros Prestadores Externos',
                  ruta: '/contrataciones/configuracion/cosegurosExternos',
                  permisos: CONFIGURACION_CONTRATOS,
                },
              ],
            },
            {
              tienePermiso: validarSoloUnPermiso(
                permisosUser,
                REPORTES_CONTRATACIONES.ADMINISTRAR,
              ),
              icon: Assignment,
              nombre: 'Reportes',
              children: [
                {
                  icon: Description,
                  nombre: 'Redes',
                  ruta: '/contrataciones/reportes/redes',
                  permisos: null,
                },
                {
                  icon: Description,
                  nombre: 'Prestadores',
                  ruta: '/contrataciones/reportes/prestadores',
                  permisos: null,
                },
                {
                  icon: Description,
                  nombre: 'Practicas',
                  ruta: '/contrataciones/reportes/prestadores-por-practica',
                  permisos: null,
                },
              ],
            },
            {
              tienePermiso: validarSoloUnPermiso(
                permisosUser,
                ARCHIVOS_CONTRATACIONES.ADMINISTRAR,
              ),
              icon: FileCopyOutlined,
              nombre: 'Archivos Contrataciones',
              ruta: '/contrataciones/archivos-contratos',
              permisos: null,
            },
          ],
        },


        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            RECLAMOS_PERMISOS,
          ]),
          icon: MenuBookSharp,
          nombre: 'CReAS',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/reclamos/home',
              permisos: RECLAMOS_PERMISOS,
            },
            {
              icon: ArtTrack,
              nombre: 'Administrar Reclamos',
              ruta: '/reclamos/administrarReclamos',
              permisos: RECLAMOS_PERMISOS,
            },
            {
              tienePermiso: validarSoloUnPermiso(
                permisosUser,
                RECLAMOS_PERMISOS.ADMIN,
              ),
              icon: Settings,
              nombre: 'Configuración',
              children: [
                {
                  icon: Description,
                  //nombre: 'Documentación por Subtipo de Efectores',
                  nombre: 'Tipos / Origen / Categorias',
                  ruta: '/reclamos/configuracion/tiposreclamos',
                }
              ],
            },
          ],
        },

        /*D*/

        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            DISCAPACIDAD_PERMISOS.MENU,
            DISCAPACIDAD_PERMISOS.CONFIGURACION,
            DISCAPACIDAD_PERMISOS.ARCHIVOS,
          ]),
          icon: Accessible,
          nombre: 'Discapacidad',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/discapacidad/home',
              permisos: DISCAPACIDAD_PERMISOS.MENU,
            },
            {
              icon: ArtTrack,
              nombre: 'Administrar Solicitudes',
              ruta: '/discapacidad/administrarSolicitudes',
              permisos: ADMINISTRAR_DISCAPACIDAD_PERMISOS,
            },
            {
              tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(
                permisosUser,
                [DISCAPACIDAD_PERMISOS.CONFIGURACION],
              ),
              icon: Home,
              nombre: 'Configuración',
              children: [
                {
                  icon: Description,
                  nombre: 'Formularios',
                  ruta: '/discapacidad/configuracion/formularios',
                  permisos: null,
                },
                {
                  icon: Description,
                  nombre: 'Nomenclador Discapacidad',
                  ruta: '/discapacidad/nomenclador',
                  permisos: DISCAPACIDAD_NOMENCLADOR_PERMISOS,
                },
                {
                  icon: Description,
                  nombre: 'Tipo de Documentación',
                  ruta: '/discapacidad/configuracion/documentacionIntegracion',
                  permisos: null,
                  onClick: () => {
                    dispatch(cleanTipoDocumentacionAbm());
                  }
                },
                {
                  icon: Description,
                  nombre: 'Tipo de Documentación Solicitud',
                  ruta: '/discapacidad/configuracion/documentacionIntegracionSolicitud',
                  permisos: null,
                  onClick: () => {
                    dispatch(cleanTipoDocumentacionAbm());
                  }
                },
                {
                  icon: Description,
                  nombre: 'Tipo de Documentación Afiliados',
                  ruta: '/discapacidad/configuracion/documentacionIntegracionAfiliados',
                  permisos: null,
                  onClick: () => {
                    dispatch(cleanTipoDocumentacionAbm());
                  }
                },
              ],
            },
            {
              tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(
                permisosUser,
                [DISCAPACIDAD_PERMISOS.ARCHIVOS],
              ),
              icon: FileCopyOutlined,
              nombre: 'Archivos',
              children: [
                {
                  icon: Description,
                  nombre: 'Carga de Archivos',
                  ruta: '/discapacidad/archivos/carga',
                  permisos: null,
                },
              ],
            },
          ],
        },

        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            ADICCIONES_PERMISOS.MENU,
            ADICCIONES_PERMISOS.CONFIGURACION,
            ADICCIONES_PERMISOS.ARCHIVOS,
          ]),
          icon: Person,
          nombre: 'Drogadependencia',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/adicciones/home',
              permisos: ADICCIONES_PERMISOS.MENU,
            },
            {
              icon: ArtTrack,
              nombre: 'Administrar Solicitudes',
              ruta: '/adicciones/administrarSolicitudes',
              permisos: ADMINISTRAR_ADICCIONES_PERMISOS,
            },
            {
              tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(
                permisosUser,
                [ADICCIONES_PERMISOS.CONFIGURACION],
              ),
              icon: Home,
              nombre: 'Configuración',
              children: [
                {
                  icon: Description,
                  nombre: 'Tipo de Documentación',
                  ruta: '/adicciones/configuracion/documentacionIntegracion',
                  permisos: null,
                  onClick: () => {
                    dispatch(cleanTipoDocumentacionAbmAdicciones());
                  }
                },
                {
                  icon: Description,
                  nombre: 'Tipo de Documentación Solicitud',
                  ruta: '/adicciones/configuracion/documentacionIntegracionSolicitud',
                  permisos: null,
                  onClick: () => {
                    dispatch(cleanTipoDocumentacionAbmAdicciones());
                  }
                },
              ],
            },
          ],
        },

        /*H*/

        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            HCE_PERMISOS,
          ]),
          icon: MenuBookSharp,
          nombre: 'Historia Clínica Electrónica',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/hce',
              permisos: HCE_PERMISOS,
              onClick: () => { resetState() }
            },
            {
              icon: Settings,
              nombre: 'Configuración',
              tienePermiso: true,
              children: [
                {
                  icon: Description,
                  nombre: 'ABM Informes',
                  ruta: '/hce/abmInformes',
                  permisos: HCE_PERMISOS,
                },
                {
                  icon: Description,
                  nombre: 'ABM Informes Odontología',
                  ruta: '/hce/abmInformesOftalmo',
                  permisos: HCE_PERMISOS,
                },
                {
                  icon: Description,
                  nombre: 'ABM Estudios Medicos',
                  ruta: '/hce/abmEstudiosMedicos',
                  permisos: HCE_PERMISOS,
                },
              ],
            },
          ],
        },

        /*L*/

        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            LIQUIDACIONES_MENU_PERMISOS,
          ]),
          icon: MonetizationOn,
          nombre: 'Liquidaciones',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/liquidaciones',
              permisos: LIQUIDACIONES_MENU_PERMISOS,
            },
            {
              icon: ArtTrack,
              nombre: 'Administrar',
              ruta: '/liquidaciones/administrarLiquidaciones',
              permisos: ADMINISTRAR_LIQUIDACIONES_PERMISOS,
            },
          ],
        },


        /*M*/
        

        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            EMPADRONAMIENTO_MENU_PERMISOS,
          ]) || validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            MEDICACION_MENU_PERMISOS,
          ]),
          icon: FolderShared,
          nombre: 'Medicación',
          children: [
            ...tiposEmpadronamiento.filter(emp => emp.idTipo === TIPO_EMPADRONAMIENTO.PACBI).map(emp=>({
              icon: Add,
              nombre: emp.descripcion,
              tienePermiso:true,
              children:[
                {
                  icon: PersonAdd,
                  nombre: 'Empadronamiento',
                  ruta: `/${emp.ruta}/empadronamiento`,
                  permisos: EMPADRONAMIENTO_MENU_PERMISOS,
                  onClick:() => {//sessionStorage.setItem("idTipoEmpadronamiento", emp.idTipo)
                    dispatch(setIdTipoEmpadronamiento(emp.idTipo))}
                },
                {
                  icon: LocalHospital,
                  nombre: 'Inicio',
                  ruta: `/${emp.ruta}/inicio`,
                  permisos: EMPADRONAMIENTO_MENU_PERMISOS,
                  onClick:() => {//sessionStorage.setItem("idTipoEmpadronamiento", emp.idTipo)
                    dispatch(setIdTipoEmpadronamiento(emp.idTipo))}
                },
                {
                  icon: ArrowForward,
                  nombre: 'Continuidad',
                  ruta: `/${emp.ruta}/continuidad`,
                  permisos: EMPADRONAMIENTO_MENU_PERMISOS,
                  onClick:() => {//sessionStorage.setItem("idTipoEmpadronamiento", emp.idTipo)
                    dispatch(setIdTipoEmpadronamiento(emp.idTipo))}
                }
              ]
            })),
            {/*
              icon: LocalHospital,
              nombre: 'Solicitud de Medicacion',
              ruta: '/medicacion',
              permisos: MEDICACION_MENU_PERMISOS,
              onClick: () => resetState()
            */},
            {
              tienePermiso: validarSoloUnPermiso(
                permisosUser,
                EMPADRONAMIENTO_MENU_PERMISOS.INGRESO_SOLICITUD_AUDITORIA
              ),
              nombre: 'Configuración',
              icon: Settings,
              children: [
                {/*
                  icon: Category,
                  nombre: 'Genéricos Cobertura 70%',
                  ruta: '/empadronamiento/medicacion310',
                  permisos: EMPADRONAMIENTO_MENU_PERMISOS,
                */},
              ],
            },
          ],
        },
        
        {
          icon: Assignment,
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            MESA_ENTRADA_PERMISOS,
          ]),
          nombre: 'Mesa de Entrada',
          children: [
            {
              icon: Home,
              ruta: '/mesa-entrada/home',
              nombre: 'Home',
              permisos: MESA_ENTRADA_PERMISOS,
            },
            {
              icon: EventNoteSharp,
              ruta: '/mesa-entrada/remitos',
              nombre: 'Remitos',
              permisos: MESA_ENTRADA_PERMISOS,
            },
            {
              icon: Settings,
              nombre: 'Configuracion',
              tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(
                permisosUser,
                [MESA_ENTRADA_PERMISOS],
              ),
              children: [
                {
                  icon: Settings,
                  nombre: 'Tramites - Destinos',
                  ruta: '/mesa-entrada/configuracion/tramites-destinos',
                  permisos: MESA_ENTRADA_PERMISOS,
                },
              ],
            },
          ],
        },


        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            ESTADISTICAS_MI_OSPEDYC,
          ]),
          icon: AssignmentInd,
          nombre: 'Mi Ospedyc',
          children: [
            {
              icon: Equalizer,
              nombre: 'Generales',
              ruta: '/estadisticas-mi-ospedyc/generales',
              permisos: ESTADISTICAS_MI_OSPEDYC,
            },
            {
              icon: People,
              nombre: 'Usuarios',
              ruta: '/estadisticas-mi-ospedyc/usuarios',
              permisos: ESTADISTICAS_MI_OSPEDYC,
            },
            {
              icon: Category,
              nombre: 'Categorias',
              ruta: '/mi-ospedyc/categorias',
              permisos: ESTADISTICAS_MI_OSPEDYC,
            },
            {
              icon: PostAdd,
              nombre: 'Formularios',
              ruta: '/mi-ospedyc/formularios',
              permisos: ESTADISTICAS_MI_OSPEDYC,
            },
          ],
        },


        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            MENU_RECUPEROS,
          ]),
          icon: Assignment,
          nombre: 'SURGE',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/surge/menu',
            },
            {
              icon: AttachFile,
              nombre: 'Archivos',
              ruta: '/surge/archivos',
              onClick: () => {
                surge.clean.archivos();
              }
            },
            {
              icon: Settings,
              nombre: 'Configuraciones',
              tienePermiso: true,
              children: [
                {
                  icon: Description,
                  nombre: 'Patologias',
                  ruta: '/surge/configuraciones/patologias',
                },
                {
                  icon: DeviceHub,
                  nombre: 'Practicas Y Dispositivos',
                  ruta: '/surge/configuraciones/practicasydispositivos',
                },
                {
                  icon: FeaturedPlayList,
                  nombre: 'Conceptos',
                  ruta: '/surge/configuraciones/conceptos',
                }
              ],
            },
          ],
        },

        /*R*/

        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            RECETAS_MENU_PERMISOS,
          ]),
          icon: LocalPharmacy,
          nombre: 'Recetas Digitales',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/recetasDigitales',
              permisos: RECETAS_MENU_PERMISOS,
              onClick: () => { resetState() }
            },
            {
              tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(
                permisosUser,
                [RECETAS_MENU_PERMISOS],
              ),
              nombre: 'Configuración',
              icon: Settings,
              children: [
                {
                  icon: Description,
                  nombre: 'Medicamentos',
                  ruta: '/recetasDigitales/configuracion',
                  permisos: RECETAS_MENU_PERMISOS,
                },
              ],
            },
          ],
        },


        {
          icon: Assignment,
          nombre: 'Reportes',
          ruta: '/reportes',
          permisos: REPORTES_PERMISOS,
        },

        /*T*/

        {
          tienePermiso: permisosTraslados.menu.main,
          icon: AirportShuttle,
          nombre: 'Traslados',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/traslados',
              permisos: permisosTraslados.menu.home,
            },
            {
              icon: FormatListNumberedRtl,
              nombre: 'Gestion de Solicitudes',
              ruta: '/traslados/gestionSolicitudes',
              permisos: permisosTraslados.menu.gestion,
            },
            {
              icon: Settings,
              nombre: 'Configuración',
              tienePermiso: permisosTraslados.menu.configuracion,
              children: [
                {
                  icon: Description,
                  nombre: "Tipo Documentación Solicitudes Traslados",
                  ruta: "/traslados/configuracion/tipo-documentacion-solicitudes",
                  permisos: null
                },
              ]
            }
          ]
        },

        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            TOTEM_PERMISOS,
            TOTEM_PERMISOS.RECEPCION,
          ]),
          icon: AspectRatio,
          nombre: 'Totem',
          children: [
            {
              icon: GroupAdd,
              nombre: 'Administración Recepcionistas Totem',
              ruta: '/totem/administracion-recepcionista',
              permisos: TOTEM_PERMISOS.RECEPCION,
            },
            {
              icon: Assignment,
              tienePermiso: validarSoloUnPermiso(
                permisosUser,
                TOTEM_PERMISOS.REPORTES,
              ),
              nombre: 'Reportes',
              children: [
                {
                  icon: Assignment,
                  nombre: 'Solicitudes Afiliados',
                  ruta: '/totem/reportes/solicitudes-afiliados',
                  onClick: () => {
                    totem.clean.solicitudesAfiliados();
                  },
                },
              ],
            },
            {
              icon: Settings,
              tienePermiso: validarSoloUnPermiso(
                permisosUser,
                TOTEM_PERMISOS.ADMINISTRAR,
              ),
              nombre: 'Configuración',
              children: [
                {
                  icon: Settings,
                  nombre: 'Opciones Totem',
                  ruta: '/totem/opciones',
                },
                {
                  icon: Settings,
                  nombre: 'SubOpciones Totem',
                  ruta: '/totem/sub-opciones',
                },
                {
                  icon: Settings,
                  nombre: 'Recepcion Totem',
                  ruta: '/totem/recepcion',
                },
                {
                  icon: Settings,
                  nombre: 'Turnos Recepciones',
                  ruta: '/totem/turnosRecepciones',
                },
              ],
            },
          ],
        },
        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            TOTEM_BASIC_PERMISOS,
            TOTEM_BASIC_PERMISOS.ADMINISTRAR,
            TOTEM_BASIC_PERMISOS.RECEPCION,
          ]),
          icon: Airplay,
          nombre: 'Totem Morón',
          children: [
            {
              icon: Home,
              nombre: 'Gestión de Recepcion',
              ruta: '/totemMoron/bandeja',
              permisos: {...TOTEM_BASIC_PERMISOS.RECEPCION, ...TOTEM_BASIC_PERMISOS.ADMINISTRAR},
            },
            {
              icon: Assignment,
              nombre: 'Reportes',
              ruta: '/totemMoron/reportes',
              permisos: { REPORTES: TOTEM_BASIC_PERMISOS.REPORTES },
            },
            {
              icon: Settings,
              tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [TOTEM_BASIC_PERMISOS.ADMINISTRAR]),
              nombre: 'Configuración',
              children: [
                {
                  icon: Inbox,
                  nombre: 'Boxes',
                  ruta: '/totemMoron/abmBoxes',
                },
                {
                  icon: List,
                  nombre: 'Opciones',
                  ruta: '/totemMoron/abmOpciones',
                },
                {
                  icon: LowPriority,
                  nombre: 'Sub Opciones',
                  ruta: '/totemMoron/abmSubOpciones',
                },
                {
                  icon: Shuffle,
                  nombre: 'Opciones por Box',
                  ruta: '/totemMoron/abmOpcionesPorBox',
                },
              ],
            },
          ],
        },
        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            CONFIGURACIONTURNOS_PERMISOS,
            ESPECIALIDADES_PERMISOS,
            FERIADOS_PERMISOS,
            LICENCIASPROFESIONALES_PERMISOS,
            MEDICOS_PERMISOS,
            MOTIVOSBAJATURNOS_PERMISOS,
            TURNOS_PERMISOS,
          ]),
          icon: Today,
          nombre: 'Turnos',
          children: [
            {
              icon: Home,
              nombre: 'Menu',
              ruta: '/turnos',
              permisos: TURNOS_PERMISOS,
            },
            {
              icon: PostAddOutlined,
              nombre: 'Certificado Atencíon',
              ruta: '/turnos/certificadoAtencion',
              permisos: TURNOS_PERMISOS,
            },
            {
              tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(
                permisosUser,
                [
                  CONFIGURACIONTURNOS_PERMISOS,
                  ESPECIALIDADES_PERMISOS,
                  FERIADOS_PERMISOS,
                  LICENCIASPROFESIONALES_PERMISOS,
                  MEDICOS_PERMISOS,
                  MOTIVOSBAJATURNOS_PERMISOS,
                ],
              ),
              icon: Settings,
              nombre: 'Configuración',
              children: [
                {
                  icon: Iso,
                  nombre: 'Alta Día Eventual',
                  ruta: '/configuracion/turnos/altaDiaEventual',
                  permisos: null,
                },
                {
                  icon: HowToReg,
                  nombre: 'Especialidades',
                  ruta: '/especialidades',
                  permisos: ESPECIALIDADES_PERMISOS,
                },
                {
                  icon: Iso,
                  nombre: 'Feriados | No Laborables',
                  ruta: '/configuracion/turnos/feriados',
                  permisos: null,
                },
                {
                  icon: Iso,
                  nombre: 'Licencias Profesionales',
                  ruta: '/configuracion/turnos/licenciasProfesionales',
                  permisos: LICENCIASPROFESIONALES_PERMISOS,
                },
                // {
                //   icon: LocalHospitalSharp,
                //   nombre: "Médicos",
                //   ruta: "/medicos",
                //   permisos: MEDICOS_PERMISOS
                // },
                {
                  icon: LocalHospitalSharp,
                  nombre: 'Médicos',
                  ruta: '/medicos',
                  permisos: null,
                },
                {
                  icon: Iso,
                  nombre: 'Motivos Baja Turnos',
                  ruta: '/configuracion/turnos/motivosBajaTurnos',
                  permisos: MOTIVOSBAJATURNOS_PERMISOS,
                },
                {
                  icon: AllInclusive,
                  nombre: 'Nombre Autopercibido',
                  ruta: '/configuracion/turnos/autopercepcion',
                  permisos: [TURNOS_PERMISOS.ALTA, TURNOS_PERMISOS.ASISTENCIA],
                },
                {
                  icon: Iso,
                  nombre: 'Parametrización Horarios',
                  ruta: '/configuracion/turnos/parametrizacionHorarios',
                  permisos: CONFIGURACIONTURNOS_PERMISOS,
                },
                {
                  icon: QueryBuilder,
                  nombre: 'Horarios de Medicos',
                  ruta: '/configuracion/turnos/horariosMedicos',
                  permisos: CONFIGURACIONTURNOS_PERMISOS,
                },
                {
                  icon: Iso,
                  nombre: 'Parametrización SobreTurnos',
                  ruta: '/configuracion/turnos/parametrizacionSobreTurnos',
                  permisos: CONFIGURACIONTURNOS_PERMISOS,
                },
                {
                  icon: Iso,
                  nombre: 'Parametrización UsuarioOspe',
                  ruta: '/configuracion/turnos/parametrizacionUsuarioOspe',
                  permisos: CONFIGURACIONTURNOS_PERMISOS,
                },
              ],
            },
          ],
        },

        {
          icon: Assignment,
          // tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
          //   USUARIOS_PERMISOS,
          // ]),
          nombre: 'Versiones Aplicación',
          children: [
            {
              icon: Home,
              ruta: '/versionesSistema',
              nombre: 'Home',
              permisos: null
            },
          ],
        },
        {
          tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
            TESORERIA_PERMISOS,
            TESORERIA_PERMISOS.CONFIGURACION
          ]),
          icon: MonetizationOnSharp,
          nombre: 'Tesoreria',
          children: [
            {
              icon: Settings,
              nombre: 'Configuración',
              tienePermiso: validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [
                TESORERIA_PERMISOS,
                TESORERIA_PERMISOS.CONFIGURACION
              ]),
              children: [
                {
                  icon: PersonAdd,
                  nombre: "Usuarios Ospedyc Directo",
                  ruta: "/tesoreria/usuariosospedirecto",
                  permisos: null
                },
              ]
            }
          ]
        },

        // {
        //   icon: PermIdentity,
        //   nombre: "Movimientos User",
        //   ruta: "/usuarios/movimientos",
        //   permisos: REPORTES_PERMISOS
        // }
      ]}
    />
  );
};
